import { IButton, TranslateService } from '@devinforius/i-essentials';
import { HomeIscanComponent } from './home-iscan.component';
import { addDays } from 'date-fns';
import { ITab } from '@devinforius/i-navigation/lib/models/i-tabsXl';
import { ITableColumn } from '@devinforius/i-table';

export function getButtonTitle(component: HomeIscanComponent, translater: TranslateService): IButton[] {
  return [
    {
      text: translater.translate('iScan.action.addPageSeparator'),
      styleClass: 'blue',
      icon: 'bi bi-hr',
      iconPosition: 'left',
      id: 'addPageSeparator',
      click: (): void => {
        component.openDialogCreateSeparatorPage = true;
      },
    },
    {
      text: translater.translate('iScan.globalInfos.newScan'),
      styleClass: 'green',
      icon: 'bi bi-plus-circle',
      iconPosition: 'left',
      id: 'newScan',
      click: (event) => {
        const target = document.getElementById('newScan');
        component.overlayButtonNewScan.toggle(event, target);
      },
    },
  ];
}

export function getColumnsScan(activeTabId: 'toProcess' | 'processed' | 'history', translater: TranslateService): ITableColumn[] {
  return [
    {
      field: 'filename',
      header: translater.translate('lastName'),
      width: activeTabId !== 'toProcess' ? '30%' : '40%',
    },
    {
      field: 'scanTypeLabel',
      header: translater.translate('iScan.globalInfos.mode'),
      width: '10%',
      format: (_value, item): string => {
        switch (item.scanType) {
          case 'Manuel':
            return translater.translate('iScan.globalInfos.manual');
          case 'QrCode':
            return translater.translate('iScan.globalInfos.qrCode');
          case 'SeparateurWithout':
            return translater.translate('iScan.globalInfos.withoutQRCode');
        }
      },
    },
    {
      field: 'pagesCount',
      header: translater.translate('iScan.globalInfos.pages'),
      width: '5%',
      format: (value): string => {
        if (value) {
          if (value === null) {
            return `/`;
          } else {
            return value;
          }
        }
      },
    },
    {
      field: 'uploadDate',
      header: translater.translate('iScan.globalInfos.importDate'),
      width: '15%',
      format: (value): string => {
        if (value) {
          const date = new Date(value);
          return new Intl.DateTimeFormat('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          }).format(date);
        }
        return value;
      },
    },
    {
      field: 'lastTransitionStatutLabel',
      header: translater.translate('iScan.globalInfos.status'),
      width: '25%',
      format: (_value, element): string => {
        const dateExpired = addDays(new Date(element.lastTransition.date), 1);
        if (element.lastTransition.statutId) {
          if (element.lastTransition.statutId === 1 && dateExpired > new Date()) {
            const creation = translater.translate('iScan.information.creation');
            return `
                <div class='status-orange-scan'>
                  <span>${creation}</span>
                  <span class="dot dot--one">.</span><span class="dot dot--two">.</span><span class="dot dot--three">.</span>
                </div>`;
          } else if (element.lastTransition.statutId === 1 && dateExpired < new Date()) {
            const lateTreatment = translater.translate('iScan.information.lateTreatment');
            const contactSupport = translater.translate('iScan.information.contactSupport');
            return `<div class='status-orange-scan'>
                  <span>${lateTreatment}<br>
                  <span class="dot--one">${contactSupport}</span>
                  </span>
                  
                </div>`;
          } else if (element.lastTransition.statutId === 2) {
            const toBeProcessed = translater.translate('iScan.information.toBeProcessed');
            return `<div class='status-blue'> ${toBeProcessed} </div>`;
          } else {
            const processed = translater.translate('iScan.information.processed');
            return `<div class='status-green'> ${processed} </div>`;
          }
        }
        return element.lastTransition.statutId;
      },
    },
    {
      field: 'listOfCourrierIds',
      header: translater.translate('iScan.globalInfos.linkedMails'),
      width: '10%',
      visible: activeTabId !== 'toProcess',
      format: (_value, item): string => {
        if (item.splits?.length) {
          let data: string = item.splits
            .filter((split) => split.courrierId)
            .map((split) => split.courrierId)
            .join(', ');
          if (data.length > 40) {
            data = data.slice(0, 40) + ', ...';
            return data;
          } else return data;
        } else return '';
      },
      tooltip: () => {
        return translater.translate('iScan.action.clickToSeeMails');
      },
    },
  ];
}

export function getColumnsMailsLinked(translater: TranslateService): ITableColumn[] {
  return [
    {
      field: 'courrierId',
      header: translater.translate('id'),
      width: '10%',
    },
    {
      field: 'courrierObjet',
      header: translater.translate('object'),
      width: '70%',
      maxWidth: '200px',
      format: (value) => {
        return value ? value : translater.translate('courrier.mailWithoutObject');
      },
    },
  ];
}

export function getTabsScan(translater: TranslateService): ITab[] {
  const tabs: ITab[] = [
    {
      label: translater.translate('iScan.information.toBeProcessed'),
      id: 'toProcess',
      icon: 'bi bi-folder2-open',
    },
    {
      label: translater.translate('iScan.information.processed'),
      id: 'processed',
      icon: 'bi bi-lock',
    },
    {
      label: translater.translate('iScan.globalInfos.historic'),
      id: 'history',
      icon: 'bi bi-archive',
    },
  ];
  return tabs;
}
